module.exports = __webpack_public_path__ + "img/MYLOGO.8737256b.png";